import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MpsGuestGuard, MpsLoggedInGuard } from '../../../mps/mps-guards';
import { MpsLoaderComponent, MpsLoaderService } from '../../../mps/mps-loader';
import { TranslateModule } from '@ngx-translate/core';
import { DialogComponent } from './components/dialog/dialog.component';
import { MatPaginatorModule} from '@angular/material/paginator';
import {MatSortModule} from '@angular/material/sort';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';



@NgModule({
    entryComponents: [
        DialogComponent,

        // MpsLoaderComponent n'est dans aucun template : MpsLoaderService l'instancie
        // via un ComponentPortal du CDK. En ViewEngine il doit donc etre liste
        // ici, sinon l'overlay echoue avec "No component factory found".

        MpsLoaderComponent,
	],
    declarations: [
        DialogComponent,
        MpsLoaderComponent
    ],
    providers: [
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 3000 } },
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        DatePipe,

        // Fournis ici, et non a la racine, pour conserver exactement la portee
        // qu'avaient les NgModules @ff/loader et @ff/core : ils etaient importes
        // par ce module.

        MpsLoaderService,
        MpsLoggedInGuard,
        MpsGuestGuard
    ],
    imports: [

        // Angular

        ReactiveFormsModule,
        FormsModule,
        CommonModule,

        // Angular Material

        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        MatTabsModule,
        MatTooltipModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        MatCardModule,
        MatSidenavModule,
        MatSnackBarModule,
        MatRadioModule,
        MatSelectModule,
        MatTableModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatPaginatorModule,
        MatSortModule,
        MatSlideToggleModule,

        // Other
        TranslateModule.forChild()
    ],
    exports: [

        ReactiveFormsModule,
        FormsModule,
        CommonModule,

        // Angular Material

        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        MatTabsModule,
        MatTooltipModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        MatCardModule,
        MatSidenavModule,
        MatSnackBarModule,
        MatRadioModule,
        MatSelectModule,
        MatTableModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatAutocompleteModule,
        MatPaginatorModule,
        MatSortModule,
        MatSlideToggleModule,

        TranslateModule,
        DialogComponent
    ]
})
export class SharedModule {

    public constructor() {

    }

}
